<template>
  <minimal-layout>
    <div class="offline-container">
      <div class="inner">
        <figure class="logo"/>
        <div class="offline-text">
          <span v-html="data.content"/>
        </div>
      </div>
    </div>
  </minimal-layout>
</template>

<script>
import MinimalLayout from '../layouts/Minimal'

export default {
  name: 'Offline',
  components: {
    MinimalLayout
  },
  props: {
    data: {
      type: Object,
      default: () => { return {title: '', content: ''} }
    }
  },
  created () {
    document.title = this.data.title
  }
}
</script>

<style>
  .offline-container {
    position: fixed;
    height: 100%;
    width: 100%;
    background: #ffffff;
    color: #333333;
    font-size: 16px;
  }

  .offline-container .inner {
    position: absolute;
    top: 50%;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    padding: 20px;
    max-width: 520px;
    max-height: 560px;
    overflow: auto;
    overflow-x: hidden;
    box-sizing: border-box;
    border: 1px solid #aaa;
  }

  figure.logo {
    position: relative;
    left: 50%;
    -ms-transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
  }

  .offline-text {
      clear: both;
  }

  h1 {
    font-size: 20px;
    margin: 0 0 20px 0;
  }

  p {
    margin: 0 0 15px 0;
    line-height: 24px;
  }

  p:last-child {
    margin: 0;
  }

  ul li {
    line-height: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Offline.vue